import { Component, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, of, Subscription ,from} from "rxjs";
import {MaterialInstance, MaterialService} from "../shared/classes/material.service";
 import {StreamsService}  from "../shared/services/streams.service";
import {WatchTokenService}  from "../shared/services/watch-token.service";

import {StreamProject} from "../shared/interfaces";
import { switchMap, catchError, map, delay} from 'rxjs/operators';
import { ActivatedRoute, Router} from '@angular/router';
 import { watchKeyParam } from '../shared/config';


@Component({
  selector: 'app-chat-embed-page',
  templateUrl: './chat-embed-page.component.html',
  styleUrls: ['./chat-embed-page.component.scss'],
 
})
export class ChatEmbedPageComponent   {
 
  
  constructor(
    public streamsService: StreamsService,
    public tokenService: WatchTokenService,
    public route:  ActivatedRoute,
      private router: Router
    ){	 
  } 

  stream: StreamProject = null
  streamSubscribtion: any = false
  initialLoading: boolean = true
  accessOk: boolean = null
  isEmbed: boolean = false
  nameFromEmbed: any = null
  keyFromEmbed: any = null
  initialLoaded:any = false
  recivedToken:any = false
	  //stream$:Observable<StreamProject>

	@HostListener('window:message', ['$event'])
	onMessage(event) { 
	   if(event.data?.type === "embedWatchOpened" && !this.recivedToken){

        if(this.stream && this.stream.publicIdentity === event.data?.publicIdentity){
          console.log('reload')
          if(!this.accessOk && event.data.token){
            this.tokenService.setToken(this.stream.publicIdentity, event.data.token)
            this.recivedToken = true
            this.reload()
          }
                  
        }

	   }
	}

  ngOnInit() { 
   
	this.load()

	
  }
  
  
   requestTokenFromFrameWatch(){
    if(!this.accessOk && this.keyFromEmbed){
      if(window.parent){

        window.parent.postMessage({type:'requestToken', publicIdentity:this.stream.publicIdentity}, '*' )

      }
    }
  }

  load(){


    this.streamSubscribtion = from(this.route.queryParams.pipe(
    
      switchMap((params: any)=>{
 
		 
		if(params[watchKeyParam]?.length){
	      this.keyFromEmbed = params[watchKeyParam]
	    }

         return this.streamsService.getPubliishByPublicKey(params['v']).pipe(

	
		 catchError((error) => {
 
                    // if(error.status === 404){ this.router.navigate(['/channel']);  return of({}) }
			this.stream = <StreamProject>{}
			return of({})	
		} ),


          switchMap((stream: any)=>{

            if(stream.accessLevel === 0){
 
              this.tokenService.deleteToken(stream.publicIdentity)
              this.accessOk = true
              return of(stream)
            }else{

                const potentialToken = this.tokenService.getToken(stream.publicIdentity)
  
                if(!potentialToken){
                  this.accessOk = false
                  return of(stream)
                } else {
 
                  return this.streamsService.checkWatchAccessToken(stream._id,potentialToken).pipe(
                    switchMap((data: any)=>{
                    
 
                      if(data.error){
                        this.tokenService.deleteToken(stream.publicIdentity)
                        this.accessOk = false
                        return of(stream)
                      }

                      
                
                      if(data.token){
                        this.tokenService.setToken(stream.publicIdentity, data.token)
                        this.accessOk = true
			this.nameFromEmbed = data.chatName || null
                        return of(stream)
                      }  else {
                        this.accessOk = false
                        return of(stream)
                      }
                      
                    }),
                    catchError((error)=>{

                      MaterialService.toast('Сталася помилка сервера')
                    
                      console.log(error)
                        const potentialToken = this.tokenService.deleteToken(stream.publicIdentity)
                    
                      this.accessOk = false
                      return of(stream)
                    }) 
                  )
                  //.subscribe((x)=>of(x))
                }
            }
    
          })
         )       
      })

    )).subscribe((stream:any)=>{
     
      this.initialLoading = false
      this.stream = stream
      if(!this.initialLoaded ){
        this.initialLoaded = true
        if(!this.recivedToken)
        this.requestTokenFromFrameWatch()
      }
    }) 
   

 


  }


	reload(){
		this.initialLoading = true
		setTimeout(()=>{this.load()}, 500)

	}

 

 
   ngOnDestroy() { 
 
      if(this.streamSubscribtion){
        // this.streamSubscribtion.unsubsceibe()
      }
    
   }


}
